import url from './url';



export default url(({ taskId = ':id' }) => `/tasks/${taskId}`);
